import { get } from 'lodash';

const styles = ({ color, fontSize, typography }) => ({
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: 6,
  },
  sectionTitle: {
    color: get(color, 'bodyText'),
    fontFamily: get(typography, 'bodyText'),
    fontSize: get(fontSize, 'sectionTitle'),
  },
  fieldContainer: {
    margin: '20px 0',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  deleteButton: {
    textTransform: 'none',
    color: get(color, 'error'),
    borderColor: get(color, 'error'),
    marginTop: -25,
  },
  formLabel: {
    color: `${get(color, 'bodyText')} !important`, // avoiding overwrite by white color
    fontFamily: get(typography, 'bodyText'),
    fontSize: get(fontSize, 'title'),
    fontWeight: 700,
    marginBottom: 10,
    '& span': {
      verticalAlign: 'middle',
    },
  },
  keyContainer: {
    display: 'grid',
  },
  keyInputContainer: {
    marginLeft: '30px',
  },
  keyDeploymentContainer: {
    marginBottom: '50px',
  },
  radio: {
    color: get(color, 'bodyText'),
    fontFamily: get(typography, 'bodyText'),
    fontSize: get(fontSize, 'bodyText'),
    fontWeight: 700,
    '& svg': {
      width: 16,
      height: 16,
    },
  },
});

export default styles;
